<template lang="html">
  <div class="eb-pt-row-login">
    <div class="row justify-content-md-center mx-1 mt-3">

      <div :class="formContainerClass">
        <component :is="getLoginProviderComponentName(this.userProvider)" v-if="showLoginProviderComponent"
          :user-email="userEmail" :return-url="returnUrl" :provider-details="loginProviderComponentDetails"
          @providerSuccessLogin="onProviderSuccessLogin" @requestChangeUsername="onRequestChangeUsername">
          <template #terms>
            <slot name="terms">
              <!-- Default disclaimer if no terms slot is provided -->
              <div class="text-center mb-3">
                <p class="small text-muted" v-html="disclaimerText">
                </p>
              </div>
            </slot>
          </template>
        </component>
        <div v-if="!providerSettingsAvailable">
          {{ this.userProvider }} settings are not available. Please contact GoFundraise administrator.
        </div>

        <div v-if="!showProviderForm" class="row justify-content-md-center">
          <div class="col mt-3">
            <div v-show="tempUserFeedback !== ''" class="alert alert-success" role="alert">
              {{ tempUserFeedback }}
            </div>

            <template v-if="isInlineTemplate">
              <h4 class="text-center mb-4 mt-4">
                Log In
              </h4>
            </template>
            <template v-else-if="isTabbedTemplate">
              <ul class="nav nav-pills col-12 mb-2 p-0 mt-4">
                <li class="nav-item btn-square col-6 m-0 p-0">
                  <a href="javascript:;" class="nav-link text-center" :class="getActiveClass('login')"
                    @click="setTab('login')">Login</a>
                </li>
                <li class="nav-item btn-square col-6 m-0 p-0">
                  <a href="javascript:;" class="nav-link text-center" :class="getActiveClass('register')"
                    @click="setTab('register')">Register</a>
                </li>
              </ul>
            </template>
          </div>
        </div>

        <div v-if="!showProviderForm" class="row justify-content-md-center">
          <div class="col mt-3">
            <div>
              <form v-if="isInlineTemplate || (isTabbedTemplate && isActiveTab('login'))">
                <div class="form-group">
                  <label for="Email" style="display:none;">Email</label>
                  <input v-show="!userEmailChecked" id="Email" v-model="userEmail" type="email" class="form-control"
                    placeholder="Email">
                  <div v-show="userEmailChecked" class="checked-email-display" @click="userEmailClicked()">
                    <span>{{ userEmail }}</span>
                    <span class="edit-icon-wrapper">
                      <span class="edit-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="feather feather-edit-2">
                          <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
                        </svg>
                      </span>
                    </span>
                  </div>
                  <div class="message_error_login email_error">
                    {{ validation.firstError('userEmail') }}
                  </div>
                </div>
                <div v-if="userEmailChecked" class="form-group">
                  <label for="Password" style="display:none;">Password</label>
                  <input id="Password" v-model="userPassword" type="password" class="form-control" placeholder="Password">
                  <div class="message_error_login password_error">
                    {{ validation.firstError('userPassword') }}
                  </div>
                </div>
                <div v-show="serverMessage !== ''" class="form-group">
                  <div class="text-danger">
                    {{ serverMessage }}
                  </div>
                </div>

                <div v-if="userEmailChecked" class="col-12">
                  <p class="font-weight-normal text-center w-100 pb-4">
                    <a href="javascript:;" @click="router().show('forgot-password', { userEmail: userEmail })">
                      Forgot your Password?
                    </a>
                  </p>
                </div>

                <div class="text-center">
                  <slot name="terms">
                    <!-- Default disclaimer if no terms slot is provided -->
                    <div class="mb-3">
                      <p class="small text-muted" v-html="disclaimerText">
                      </p>
                    </div>
                  </slot>
                </div>

                <div class="form-group my-3">
                  <div class="row justify-content-md-center">
                    <div class="col-md-8">
                      <vue-recaptcha v-if="captchaPublicKey != ''" ref="invisibleRecaptcha" size="invisible"
                        :sitekey="captchaPublicKey" @verify="RecaptchaAsVerified" />
                      <button v-if="userEmailChecked" id="btnSubmit" type="button"
                        class="btn btn-block gf-driver-button-color gf-driver-background-bg"
                        @click="submitGfLoginAccount">
                        <span class="primary-text">Login</span>
                      </button>
                      <button v-if="!userEmailChecked" id="btnContinue" type="button"
                        class="btn btn-block gf-driver-button-color gf-driver-background-bg" @click="submitEmailAddress">
                        <span class="primary-text">Continue</span>
                      </button>
                    </div>
                  </div>
                </div>

              </form>

              <template v-if="isTabbedTemplate && isActiveTab('register')">
                <Register :facebook="facebook" :returnUrl="returnUrl" :formContainerClass="''"
                  :accountLink="linkAccountMode" :accessToken="accessToken" :disableRedirect="disableRedirect"
                  :hide-title="true" :hideLoginLink="isTabbedTemplate" @logged-in="$emit('loggedIn')">
                  <template #terms>
                    <slot name="terms">
                      <!-- Default disclaimer for register tab -->
                      <div class="text-center mb-3">
                        <p class="small text-muted" v-html="disclaimerText">
                        </p>
                      </div>
                    </slot>
                  </template>
                </Register>
              </template>
            </div>

          </div>

          <template v-if="isInlineTemplate || (isTabbedTemplate && isActiveTab('login'))">
            <!-- component facbook -->
            <LoginFacebookInitializer
              v-show="!userEmailChecked && !inApp && facebook.appId != '' && linkAccountMode !== true" :in-frame="inFrame"
              :return-url="returnUrl" :provider="provider" :facebook="facebook" :demo="demo" @tokenError="onTokenError"
              @logged-in="$emit('loggedIn')" />
            <!-- end component facebook -->
            <template v-if="isInlineTemplate">
              <div class="col-12 pt-2">
                <p class="d-inline pl-5">Do not have an account?</p>
                <p class="d-inline pr-5 float-right">
                  <a href="javascript:;" class="btn-signup" @click="
                    router().show('register', { accountLink: linkAccountMode, accessToken: accessToken })
                    ">
                    Sign up
                  </a>
                </p>
              </div>
            </template>
          </template>


        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { provide, ref, computed } from 'vue'
import LoginAccountInitializer from './LoginAccountInitializer.vue'
import LoginFacebookInitializer from './LoginFacebookInitializer.vue'
import LoginCognitoInitializer from './LoginCognitoInitializer.vue'
import LoginProviderFactory from './LoginProviderFactory.vue'
import Register from '../register/register.vue'
import useAppRouter from '../../composables/useAppRouter'
import store from '../../store'

export default {
  components: { LoginFacebookInitializer, LoginCognitoInitializer, Register },
  mixins: [LoginAccountInitializer, LoginProviderFactory],
  props: [
    'facebook',
    'captchaPublicKey',
    'provider',
    'returnUrl',
    'inFrame',
    'formContainerClass',
    'demo',
    'accountLink',
    'accessToken',
    'providerDetails',
    'disableRedirect'
  ],
  setup() {
    const isInitialSetup = ref(false)
    const isPasswordSetupRequired = ref(false)
    const appProps = ref(store.state.appProps)
    const isInlineTemplate = computed(
      () => appProps.value.template === 'inline' || appProps.value.template === ''
    )
    const isTabbedTemplate = computed(
      () => appProps.value.template === 'tabLayout' || appProps.value.template === 'tab'
    )
    const activeTab = ref('login')

    const setTab = (name) => {
      activeTab.value = name
    }

    const isActiveTab = (tabName) => {
      return activeTab.value === tabName
    }

    const getActiveClass = (tabName) => {
      return isActiveTab(tabName) ? 'active' : ''
    }

    provide('isInitialSetup', isInitialSetup)
    provide('isPasswordSetupRequired', isPasswordSetupRequired)


    return {
      isInitialSetup,
      isPasswordSetupRequired,
      isInlineTemplate,
      isTabbedTemplate,
      isActiveTab,
      getActiveClass,
      appProps,
      activeTab,
      setTab
    }
  },
  data() {
    return {
      inApp: false,
      router: useAppRouter
    }
  },
  computed: {
    showLoginProviderComponent() {
      return (
        this.userEmailChecked && this.showProviderForm && this.loginProviderComponentDetails != null
      )
    },
    loginProviderComponentDetails() {
      var vm = this
      var userProviderDetails = this.providerDetails.find(function (e) {
        return e.name.toLowerCase() == vm.userProvider.toLowerCase()
      })
      return userProviderDetails == null ? null : userProviderDetails.details
    },
    providerSettingsAvailable() {
      return (
        this.userProvider == '' ||
        (this.showProviderForm && this.loginProviderComponentDetails != null)
      )
    },
    disclaimerText() {
        return 'By logging in, registering, or creating a page, you agree to the Event & Site <a href="/terms-of-use" target="_blank">Terms & Conditions</a> and acknowledge our <a href="/privacy-policy" target="_blank">Privacy & Cookie</a>, and <a href="/data-collection-policy" target="_blank">Data Collection</a> Policies.';
    }
  },
  mounted: function () {
    var ua = navigator.userAgent || navigator.vendor || window.opera
    this.inApp = ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1
    this.$gfLogger.logInfo('login.vue mounted, inApp: ', this.inApp)
    this.$gfLogger.logInfo('login.vue mounted, facebook: ', this.facebook)
    this.$gfLogger.logInfo(
      'login.vue mounted, accountLink route param: ',
      this.router().getRouteParams('accountLink')
    )

    if (this.router().getRouteParams('tempUserFeedback')) {
      this.tempUserFeedback = this.router().getRouteParams('tempUserFeedback')
    }

    if (this.router().getRouteParams('email_receive')) {
      this.userEmail = this.router().getRouteParams('email_receive')
    }

    if (
      this.router().getRouteParams('accessToken') &&
      this.router().getRouteParams('accessToken').length > 0
    ) {
      this.$gfLogger.logInfo(`Received accessToken: ${this.router().getRouteParams('accessToken')}`)
      this.accountAccessToken = this.router().getRouteParams('accessToken')
      if (this.captchaPublicKey !== '') {
        this.$refs.invisibleRecaptcha.reset()
      }
    }

    if (
      this.router().getRouteParams('accountLink') &&
      this.router().getRouteParams('accountLink') === true
    ) {
      this.linkAccountMode = true
      this.$gfLogger.logInfo('login.vue mounted, linkAccountMode: ', this.linkAccountMode)
    }
  },
  methods: {
    onProviderSuccessLogin(param) {
      this.$gfLogger.logInfo('Login.onProviderSuccessLogin.param', param)

      if (this.linkAccountMode && this.accountAccessToken && this.accountAccessToken.length > 0)
        return this.linkAccount()

      if (this.disableRedirect) {
        this.$emit('loggedIn', param.userName)
        this.$gfLogger.logInfo('onProviderSuccessLogin triggered!', param)
        return
      }

      this.$gfLogger.logInfo('onProviderSuccessLogin redirect to return URL', param.returnURL)

      if (typeof param.returnURL != 'undefined') window.location.replace(param.returnURL)
    },
    onTokenError: function (message) {
      this.serverMessage = message
    },
    userEmailClicked: function () {
      this.userEmailChecked = false
      this.serverMessage = ''
    },
    onRequestChangeUsername() {
      this.userEmailChecked = false
      this.showProviderForm = false
      this.userProvider = ''
      this.serverMessage = ''
    }
  }
}
</script>
<style scoped>
a.nav-link {
  color: #999;
  cursor: pointer;
}

.nav-pills .nav-link {
  border-radius: 0;
}

.nav-pills .nav-link.active {
  background-color: #fff;
  color: #f57c33;
}

.nav-item {
  background: #e8e8e8;
  color: #999;
}

li.nav-item {
  border: 0;
}
</style>